import { Button, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { IconPlus } from '@tabler/icons';
import FileCard from './FileCard';
import { StandaloneFormInlineInput } from '../Sections';

type AttachmentFieldProps = {
    disabled?: boolean;
};

export const AttachmentField: FC<AttachmentFieldProps> = ({ disabled }) => {
    const docRef = React.useRef<HTMLInputElement | null>(null);

    const [files, setFiles] = useState<Record<string, File | null>>({
        sifXmlFile: null,
        document: null,
        approvalFile: null,
        completeSifFile: null,
        endUserPoFile: null,
        dealerPoFile: null
    });

    const handleFileUpload = (name: string) => (e: any) => {
        const file = e.target.files[0];
        setFiles({
            ...files,
            [name]: file
        });
    };

    const handleClearInput = (name: string) => (inputRef: HTMLInputElement) => {
        setFiles({
            ...files,
            [name]: null
        });
        inputRef.value = '';
    };

    return (
        <>
            <StandaloneFormInlineInput
                label=""
                formComponent={
                    <>
                        <input type="file" ref={docRef} onChange={handleFileUpload('attachment')} style={{ display: 'none' }} />
                        <Button
                            onClick={() => (docRef.current ? docRef.current.click() : null)}
                            fullWidth
                            sx={{ height: '40px', borderRadius: '8px' }}
                            variant="outlined"
                            color="secondary"
                            disabled={disabled}
                        >
                            <IconPlus width={18} height={22} />
                            <Typography fontWeight={500} fontSize="14px">
                                Add Attachments
                            </Typography>
                        </Button>
                    </>
                }
            />

            {Object.keys(files).map(
                (key) => files[key] && <FileCard key={key} file={files[key]} onRemove={() => handleClearInput(key)(docRef.current!)} />
            )}
        </>
    );
};

export default AttachmentField;
